import {
  BatchCandidateDetailResponse,
  CandidateDetailRecord,
  CandidateStatusDto,
  CycleStatusResponseDto,
} from '../types/api';

// The deployed backend and the local one can disagree on numeric field
// serialization: older backend builds send "22" where current ones send 22.
// Map lookups keyed by candidateNumber (image map, CSV enrichment) and
// numeric comparisons (team filter) miss silently on the string form, so
// every candidate payload is normalized once, at the ApiService boundary,
// instead of trusting the declared types across the version-skew gap.

function toNum<T>(v: T): T {
  if (v == null || typeof v === 'number') return v;
  const n = Number(v);
  return (Number.isNaN(n) ? v : n) as T;
}

export function normalizeCandidateStatus<T extends CandidateStatusDto>(c: T): T {
  return {
    ...c,
    candidateNumber: toNum(c.candidateNumber),
    teamNumber: toNum(c.teamNumber),
    candidatePersonalMatam: toNum(c.candidatePersonalMatam),
    finalCycleScore: toNum(c.finalCycleScore),
    finalSocioScore: toNum(c.finalSocioScore),
    finalAssesmentScore: toNum(c.finalAssesmentScore),
    finalInterviewScore: toNum(c.finalInterviewScore),
    teamleadRank: toNum(c.teamleadRank),
  };
}

export function normalizeCycleStatus(resp: CycleStatusResponseDto): CycleStatusResponseDto {
  return {
    ...resp,
    teams: resp.teams.map(team => ({
      ...team,
      teamNumber: toNum(team.teamNumber),
      candidates: team.candidates.map(normalizeCandidateStatus),
    })),
  };
}

export function normalizeCandidateDetailBatch(resp: BatchCandidateDetailResponse): BatchCandidateDetailResponse {
  return {
    ...resp,
    candidates: resp.candidates.map(c => normalizeCandidateStatus<CandidateDetailRecord>(c)),
  };
}
